import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Iframe/iframe.container"
    ).then((module) => ({
        default: module.Iframe
    }))
);
